import { API } from 'aws-amplify'
import config from './Config'

const apiPath = config.apiGatewaySandbox.PATH

class SandboxClient {
	listLeads(site, from, to, product) {
		return API.post(apiPath, 'sandbox-ui/list', {
			body: { site, from, to, product }
		})
	}

	getLead(site, date, leadId) {
		return API.post(apiPath, 'sandbox-ui/get', {
			body: { site, date, leadId }
		})
	}
}

export default SandboxClient
